import { render, staticRenderFns } from "./UiProfileCover.vue?vue&type=template&id=1bd29f20&"
import script from "./UiProfileCover.vue?vue&type=script&lang=js&"
export * from "./UiProfileCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports